// extracted by mini-css-extract-plugin
export var favorite = "styles-module__favorite___ErTKJ";
export var selected = "styles-module__selected___ef1Ww";
export var onWhiteBg = "styles-module__onWhiteBg___xs5Uc";